<template>
  <div>
    <b-card
      class="mb-75"
      no-body
      :style="isEmptyObject(item) ? 'opacity: 0.4;' : ''"
    >
      <b-card-body v-if="isEmptyObject(item)">
        <b-card-text class="text-center">
          <span>Seleccione alguna notificación para ver sus detalles</span>
        </b-card-text>
      </b-card-body>

      <div v-else>
        <b-card-header class="pb-0">
          <b-media no-body>
            <b-media-body>
              <small class="text-muted">Emitida: <b>{{ timestampToDate(item.fecha, 'LLLL') }}</b></small>
              <small class="text-muted d-block">Dirigida a: <b>{{ item.tabla_destino }}</b></small>
              <small
                v-if="item.expira"
                class="text-muted d-block"
              >Expira: <b>{{ timestampToDate(item.expira, 'LLLL') }}</b></small>
            </b-media-body>
          </b-media>
          <b-badge
            pill
            :variant="`light-${notificationPriority(item.prioridad)}`"
          >
            {{ item.prioridad }}
          </b-badge>
        </b-card-header>

        <div class="px-2 my-75">
          <h5 class="mb-0 ">
            {{ item.titulo }}
          </h5>
        </div>

        <hr class="my-0 mx-1">

        <b-card-body class="mail-message-wrapper pt-2">
          <!-- eslint-disable vue/no-v-html -->
          <div v-html="item.mensaje" />
          <!-- eslint-enable -->
        </b-card-body>

        <b-row class="text-center mx-0">
          <b-col
            cols="6"
            class="border-top border-right d-flex align-items-between flex-column py-1"
          >
            <b-card-text class="text-muted mb-0">
              Estatus de notificación
            </b-card-text>
            <h5 class="font-weight-bolder mb-50">
              {{ (item.activo) ? 'Activa' : 'Inactiva' }}
            </h5>
          </b-col>

          <b-col
            cols="6"
            class="border-top d-flex align-items-between flex-column py-1"
          >
            <b-card-text class="text-muted mb-0">
              Cantidad de vistas
            </b-card-text>
            <h5 class="font-weight-bolder mb-0">
              {{ item.viewsCount }}
            </h5>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-row v-if="item.url && !isEmptyObject(JSON.parse(item.url))">
      <b-col cols="12">
        <b-card>
          <div class="d-flex justify-content-between">
            <h5 class="mb-0">
              Presione para ver
              <b-link
                v-if="JSON.parse(item.url).tipo === 0"
                :to="JSON.parse(item.url).link"
              >
                contenido
              </b-link>
              <b-link
                v-if="JSON.parse(item.url).tipo === 1"
                target="_blank"
                :href="JSON.parse(item.url).link"
              >
                liga
              </b-link>
              enviad{{ JSON.parse(item.url).tipo === 0 ? 'o' : 'a' }}
            </h5>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardText,
  BMedia,
  BMediaBody,
  BBadge,
  BRow,
  BCol,
  BLink,
} from 'bootstrap-vue'
import { isEmptyObject } from '@core/utils/utils'
import {
  timestampToDate,
  notificationPriority,
} from '@core/utils/filter'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardText,
    BMedia,
    BMediaBody,
    BBadge,
    BRow,
    BCol,
    BLink,
  },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {
      isEmptyObject,
      timestampToDate,
      notificationPriority,
    }
  },
}
</script>
